import React, { Component, PropTypes } from 'react';
import Icon from '../../tc-ui/icon';
import { getIn } from '../../../utils/functional';

class Phone extends Component {

  getEditPhoneIcon = () => {
    const { profileToShow, routeName } = this.props;
    return (
      <div
        style={{ display: 'inline-block', marginLeft: '8px' }}
        className="profile-edit-icon-container"
        onClick={this._editPhone}
      >
        <Icon className="tc-icon-mode_edit profile-edit-icon"/>
        {profileToShow.phone ? 'EDIT' : (() => {
          let routeDisplay = '';
          if (routeName === 'profile') routeDisplay = 'Company';
          if (routeName === 'location') {
            routeDisplay = 'Location';
          }
          if (routeName === 'product') routeDisplay = 'Product';
          return `Add ${routeDisplay} Phone`;
        })()
        }
      </div>
    );
  };

  _editPhone = () => {
    const { editField, routeName } = this.props;
    const route = routeName === 'product' ? 'location' : undefined;
    editField('phone', { type: 'phone', specifiedRoute: route, isRequired: true });
  };

  render() {
    const { profileToShow, isEditable, routeName, basicUser, user } = this.props;
    const phone = profileToShow.phone && routeName !== 'product' ? profileToShow.phone : null;
    // if (basicUser && getIn(['connectionInfo', 'status'], profileToShow) !== 'accepted' && getIn(['user', 'userID'], user) !== profileToShow.companyId) return false;
    return (
      <span style={{ display: 'block', whiteSpace: 'pre-wrap' }} id="phone">
        {phone}
        {routeName !== 'product' && isEditable ? this.getEditPhoneIcon() : null}
      </span>
    );
  }
}

Phone.propTypes = {
  profileToShow: PropTypes.object,
  isEditable: PropTypes.bool,
  routeName: PropTypes.string,
  editField: PropTypes.func,
  basicUser: PropTypes.bool,
  user: PropTypes.object,
};

export default Phone;



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-top-bar/phone.jsx